export interface DataSources {
  mail: boolean;
  sharepoint: boolean;
  teams_chats: boolean;
  teams_meetings: boolean;
  people: boolean;
}

export const DEFAULT_DATA_SOURCES: DataSources = {
  mail: false,
  sharepoint: false,
  teams_chats: false,
  teams_meetings: false,
  people: false,
};

export type DictationLanguage = 'en-US' | 'de-DE' | 'fr-FR'  | 'it-IT' | 'es-ES' | 'da-DK' | 'zh-CN' | 'zh-TW';

export interface Conversation {
  id: string;
  title: string;
  created_date: string;
  updated_date: string;
  created_by: string;
  messages_ids: string[];
  is_favourite: boolean;
  agent_key?: string;
  last_used_model?: string;
  message_count?: number;  // Actual count of messages in this conversation
  data_sources?: DataSources;
  dictation_language?: DictationLanguage;
}

export interface CreateConversation {
  title: string;
  created_by?: string;
  messages_ids?: string[];
  is_favourite?: boolean;
  agent_key?: string;
  last_used_model?: string;
  dictation_language?: DictationLanguage;
}